import { useSchemaOrg } from '@unhead/schema-org/react';

/**
 * @type {import('$types/components/partials/articles').ArticleListingSchema}
 */

const ArticleListingSchema = ({ page, url }) => {
    const articles = page.items?.edges
        ?.filter(edge => edge.node?.title && edge.node?.url)
        ?? [];

    const itemListElement = articles.map((edge, i) => ({
        '@type': 'ListItem',
        position: i + 1,
        name: edge.node.title,
        url: edge.node.url,
    }));

    const schema = {
        '@type': 'WebPage',
        name: page.landing?.title || page?.title,
        url: url,
        mainEntity: {
            '@type': 'ItemList',
            itemListElement,
        },
        publisher: {
            '@type': 'RealEstateAgent',
            name: 'Beauchamp',
        },
    };

    if (page?.searchDescription) {
        schema.description = page.searchDescription;
    }

    if (page.landing) {
        schema.breadcrumb = {
            '@type': 'BreadcrumbList',
            itemListElement: [
                {
                    '@type': 'ListItem',
                    position: 1,
                    name: page.landing.title,
                    item: page.landing.url,
                },
                {
                    '@type': 'ListItem',
                    position: 2,
                    name: page.title,
                    item: url,
                },
            ],
        };
    }

    if (page?.lastPublishedAt) {
        schema.lastReviewed = page.lastPublishedAt;
    }

    useSchemaOrg(page ? [schema] : [], { tagPosition: 'head' });

    return null;
};

export default ArticleListingSchema;
